'use strict';

angular.module('client.services').factory('UnifiedSyncService', ['$resource', 'api_server',
  function ($resource, api_server) {
    var baseUrl = api_server + '/admin/licenses';
    
    return $resource(baseUrl, {}, {
      preflight: {
        method: 'GET',
        url: baseUrl + '/users/:userId/classes/preflight',
        isArray: false,
        params: {
          userId: '@userId',
          integrationId: '@integrationId'
        }
      },
      getSyncEnabledClasses: {
        method: 'GET',
        url: baseUrl + '/users/:userId/classes/sync-enabled',
        isArray: false,
        params: {
          userId: '@userId',
          integrationId: '@integrationId'
        }
      },
      importClass: {
        method: 'POST',
        url: baseUrl + '/oneroster/import-class',
        isArray: false
      },
      unarchiveClass: {
        method: 'PUT',
        url: baseUrl + '/classes/:cid/unarchive',
        isArray: false,
        params: {
          cid: '@cid'
        }
      },
      archiveClass: {
        method: 'PUT',
        url: api_server + '/classes/:cid/archive',
        isArray: false,
        params: {
          cid: '@cid'
        }
      },
      syncClass: {
        method: 'POST',
        url: baseUrl + '/classes/:cid/sync',
        isArray: false,
        params: {
          cid: '@cid'
        }
      }
    });
  }]);


